export default __webpack_public_path__ + "static/media/next.80bf1edc.png";